import React, { Fragment } from 'react';
import MetaTags from 'react-meta-tags';

import Loading from '../blocks/loading/Loading';
import HomeHeader from '../blocks/header/HomeHeader';
import Footer from '../blocks/footer/Footer';

import PageTitleHome from '../blocks/page-title/PageTitleHome';
import HomeInfo from '../blocks/home/HomeInfo';
import AboutUs from '../blocks/home/AboutUs';
import Treatments from '../blocks/home/Treatments';
import Appointments from '../blocks/home/Appointments';
import OurTeam from '../blocks/home/OurTeam';
import ContactsUs from "../blocks/home/ContactsUs";
import GoogleMaps from "../blocks/maps/GoogleMaps";

const Home = () => {
    document.body.classList.add( 'home' );
    document.body.classList.add( 'header-absolute-true' );
    document.body.classList.add( 'header-fixed-true' );
    
    return (
        <Fragment>
            <MetaTags>
                <meta charSet="UTF-8" />
                <title>Botany Physio | Home</title>

                <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="Trusted physiotherapy clinic in Botany, East Auckland. Expert care for injury recovery, rehab, and mobility. Contact us today." />
                <meta name="keywords" content="physiotherapy, Botany physio, East Auckland physio, injury rehabilitation, sports physiotherapy, back pain treatment, physiotherapy clinic, mobility therapy, Auckland physio, manual therapy, physio near me, ACC physio Botany, post-surgery rehab, botany, Meadowlands Physio, Howick Physio" />
                <meta name="robots" content="index, follow, noodp" />
                <meta name="googlebot" content="index, follow" />
                <meta name="google" content="notranslate" />
                <meta name="format-detection" content="telephone=no" />
            </MetaTags>

            <Loading />

            <HomeHeader />

            <main id="main" className="site-main content-no-spacing">
                <div className="content">
                    <div className="clearfix">
                        <PageTitleHome />

                        <HomeInfo />

                        <AboutUs />

                        <Appointments />

                        <Treatments />

                        <OurTeam />

                        <ContactsUs />

                        <GoogleMaps />
                    </div>
                </div>
            </main>

            <Footer />
        </Fragment>
    );
};

export default Home;
